import React from 'react';
import { Grid, Mui, MuiIcons } from '@leap4/frontend';

const { Box, TextField, IconButton, Typography, Button } = Mui;
const { AddCircleOutline, RemoveCircleOutline } = MuiIcons;

interface FieldConfig {
    label: string;
    required: boolean;
    gridSize?: number;
}

interface ArrayInputComponentProps<T> {
    fieldsConfig: Record<keyof T, FieldConfig>;
    initialData?: T[];
    onSubmit: (data: T[]) => void;
    title?: string;
}

const ArrayInputComponent = <T extends { [K in keyof T]: string }>({
                                                                       fieldsConfig,
                                                                       initialData = [],
                                                                       onSubmit,
                                                                       title,
                                                                   }: ArrayInputComponentProps<T>) => {




    const handleAddField = () => {

        onSubmit([...initialData, createEmptyField(fieldsConfig)]);
    };

    const handleRemoveField = (index: number) => {
        if (initialData.length > 1) {
            onSubmit(initialData.filter((_, i) => i !== index));
        }
    };

    const handleChange = (index: number, fieldName: keyof T, value: string) => {
        const updatedFields = [...initialData];
        updatedFields[index] = { ...updatedFields[index], [fieldName]: value };
        onSubmit(updatedFields);
    };

    return (
        <Box p={3} border={1} borderRadius={2} borderColor="grey.300">
            {title && (
                <Typography variant="h6" gutterBottom>
                    {title}
                </Typography>
            )}
            {initialData.map((field, index) => (
                <Grid container spacing={2} alignItems="center" key={index}>
                    {(Object.keys(fieldsConfig) as Array<keyof T>).map((name) => (
                        <Grid item xs={fieldsConfig[name].gridSize || 5} key={name as string} paddingBottom={2}>
                            <TextField
                                label={fieldsConfig[name].label}
                                variant="outlined"
                                fullWidth
                                required={fieldsConfig[name].required}
                                value={field[name]}
                                onChange={(e) => handleChange(index, name, e.target.value)}
                            />
                        </Grid>
                    ))}
                    <Grid item xs={2}>
                        <IconButton
                            color="error"
                            onClick={() => handleRemoveField(index)}
                            disabled={initialData.length === 1}
                        >
                            <RemoveCircleOutline />
                        </IconButton>
                    </Grid>
                </Grid>
            ))}
            <Box mt={2}>
                <Button
                    variant="outlined"
                    startIcon={<AddCircleOutline />}
                    onClick={handleAddField}
                >
                    Add Field
                </Button>
            </Box>
        </Box>
    );
};

function createEmptyField<T extends { [K in keyof T]: string }>(
    fieldsConfig: Record<keyof T, FieldConfig>
): T {
    const emptyField = {} as { [K in keyof T]: string };
    (Object.keys(fieldsConfig) as Array<keyof T>).forEach((key) => {
        emptyField[key] = '';
    });
    return emptyField as T;
}

export default ArrayInputComponent;
